import { buildPlainNodesfromMenu } from '@sonifi/wb-tree/utils/helper';
import countBy from 'lodash/countBy';
import { MAX_CHILDREN } from '../../../constants/wbInRoomDiningConstants';
import { isBranch } from '../../../store/menu/irdMenuSliceHelper';

export const verifyIrdMenuStructure =
  ({ superStrict }) =>
  (_, getState) => {
    const {
      irdMenu: { irdMenu, productSettings },
      irdSettings: { irdSettings },
    } = getState();

    try {
      const notifications = { errors: [], warnings: [] };
      const strictnessTarget = superStrict
        ? notifications.errors
        : notifications.warnings;
      let orderingModeIsCorrect = true;
      if (
        superStrict &&
        irdSettings.ordering_mode === 'email' &&
        !productSettings.available_ordering_modes.email
      ) {
        orderingModeIsCorrect = false;
        notifications.errors.push(
          'Your site was last published as Email. This option is no longer available.  Please check Settings Tab.',
        );
      }

      if (
        superStrict &&
        irdSettings.ordering_mode === 'read_only' &&
        !productSettings.available_ordering_modes.read_only
      ) {
        orderingModeIsCorrect = false;
        notifications.errors.push(
          'Your site was last published as Read Only. This option is no longer available.  Please check Settings Tab.',
        );
      }

      if (
        superStrict &&
        irdSettings.ordering_mode === 'on_site' &&
        !productSettings.available_ordering_modes.on_site
      ) {
        orderingModeIsCorrect = false;
        notifications.errors.push(
          'Your site was last published as On Site Fulfillment. This option is no longer available.  Please check Settings Tab.',
        );
      }

      if (orderingModeIsCorrect) {
        if (
          superStrict &&
          (irdSettings.ordering_mode === 'email' ||
            irdSettings.ordering_mode === 'on_site') &&
          irdSettings.email_addresses.length === 0
        ) {
          notifications.errors.push(
            'An email address must be set in Settings before the content can be published.',
          );
        }

        if (
          superStrict &&
          irdSettings.ordering_mode === 'on_site' &&
          !irdSettings.printer_ip
        ) {
          notifications.errors.push(
            'A printer ip must be set in Settings before the content can be published.',
          );
        }
      }

      if (superStrict && !irdMenu.menu.active) {
        notifications.errors.push(
          'Publishing requires at least one entry to be active.',
        );
      }

      const menuIds = [];
      for (let count = 0; count < irdMenu.menu.children.length; count++) {
        menuIds.push(irdMenu.menu.children[count].id);
      }

      const plainMenuNodes = buildPlainNodesfromMenu({
        menu: irdMenu.menu,
        init: true,
      });

      for (const node of plainMenuNodes) {
        // check for non-categories with childrens
        if (
          node.subject &&
          node.children &&
          !isBranch(node) &&
          node.children.length > 0
        ) {
          notifications.errors.push(
            `${node.subject.title}: An error happened and there are nodes assigned to this item`,
          );
        }

        // check for deleted nodes
        if (node.subject.isZombie) {
          notifications.errors.push(
            'An error happened and a node has been deleted. Tip! Move connected nodes as ' +
              'necessary and delete the node.',
          );
        }

        if (!superStrict) {
          const end = node.subject.delivery_end;
          const start = node.subject.delivery_start;

          if (!!end && !!start && menuIds.indexOf(node.id) === -1) {
            const title = node.subject.title;
            notifications.errors.push(
              'By moving ' + title + ', settings may have changed',
            );
          }
        }

        if (node.active && node.subject.hasDeletedContent) {
          strictnessTarget.push(
            `${node.subject.title}: References deleted content that should be properly ` +
              'removed before publishing.',
          );
        }

        if (node.active && isBranch(node)) {
          const { true: activeCount } = countBy(node.children, 'active');

          if (activeCount > MAX_CHILDREN) {
            notifications.errors.push(
              `${node.subject.title}: Has ${activeCount} active children, but only ${MAX_CHILDREN} are supported.`,
            );
          }
        }
      }
      return notifications;
    } catch (error) {
      console.error(error);
    }
  };
